import { formatMarkdownContent } from '../../../common/TipTapEditor';
import { AdhocUpdate } from '../types';

interface AdhocUpdateDetailViewProps {
  item: AdhocUpdate;
}

export function AdhocUpdateDetailView({
  item,
}: AdhocUpdateDetailViewProps): JSX.Element {
  return (
    <div className="space-y-4">
      <p className="text-gray-700 whitespace-pre-wrap">
        {formatMarkdownContent(item.description)}
      </p>
    </div>
  );
}
